import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from '@app/core/http';

@Component({
  selector: 'app-pre-init',
  templateUrl: './pre-init.component.html',
})
export class PreInitComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParams['token'];
    const init = this.generalService.preInitialize(token);
    if (init) {
      this.router.navigate(['pay-by-link']);
    }
  }
}
